import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";

@Component({
  selector: 'logzy-reply-doc-station',
  templateUrl: './reply-doc-station.component.html',
  styleUrls: ['./reply-doc-station.component.scss']
})
export class ReplyDocStationComponent extends BaseControlValueAccessor implements OnInit {

  @Input()
  replyingName: string = "";
  @Input()
  replyingToTiming: string = "";
  @Input()
  replyingto: string = "";
  @Input()
  chatBox: boolean = false;
  @Input()
  showFile: boolean = false;

  @Input()
  uploadFile: any;
  @Input()
  loading: boolean = false;
  @Output()
  uploadFileChange = new EventEmitter<any>();
  @Output()
  chatBoxChange = new EventEmitter<boolean>();
  @Output()
  showFileChange = new EventEmitter<boolean>();


  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  cancel(ch: boolean) {
    this.chatBox = !ch;
    this.chatBoxChange.emit(this.chatBox);
  }
  readableFileSize(size) {
    var units = ['B', 'KB', 'MB'];
    var i = 0;
    while (size >= 1024) {
      size /= 1024;
      ++i;
    }
    return size?.toFixed(2) + ' ' + units[i];
  }
  removeDoc(idx) {
    this.uploadFile.splice(idx, 1);
    this.uploadFileChange.emit(this.uploadFile);
  }

}
